export default __webpack_public_path__ + "static/media/donate.8baa5561.svg";